import isEqualWith from 'hs-lodash/isEqualWith';
import isEqual from 'hs-lodash/isEqual';
import { isEqualToDateOperation, isBetweenDatesOperation, isNotBetweenDatesOperation, isAfterDateOperation, isBeforeDateOperation, isMoreThanXDaysAgoOperation, isMoreThanXDaysFromNowOperation, isLessThanXDaysAgoOperation, isLessThanXDaysFromNowOperation, isAfterPropertyOperation, isBeforePropertyOperation, isUpdatedInLastXDaysOperation, isNotUpdatedInLastXDaysOperation, isUpdatedAfterPropertyOperation, isUpdatedBeforePropertyOperation
// https://hubspot.slack.com/archives/CA3JB5WLT/p1691582311466039?thread_ts=1691525228.389409&cid=CA3JB5WLT
// bend-lint-disable-next-line strict-exports
} from 'customer-data-filters-ui/converters/objectSeg/timeFilters/timeFiltersUtils';
export const TIME_POINT_UI_ALLOWED_EVENT_OPERATORS = ['IS_EQUAL', 'IS_BETWEEN', 'IS_NOT_BETWEEN'];
export const TIME_POINT_UI_BLOCKED_OPERATORS = ['IS_AFTER_DATE', 'IS_AFTER_PROPERTY', 'IS_BEFORE_DATE', 'IS_BEFORE_PROPERTY', 'IS_UPDATED_AFTER_PROPERY', 'IS_UPDATED_BEFORE_PROPERTY'];
export const TIME_POINT_UI_ALLOWED_LIST_OPERATORS = ['IS_MORE_THAN_X_DAYS_AGO', 'IS_MORE_THAN_X_DAYS_FROM_NOW', 'IS_LESS_THAN_X_DAYS_AGO', 'IS_LESS_THAN_X_DAYS_FROM_NOW', 'IS_UPDATED_IN_LAST_X_DAYS', 'IS_NOT_UPDATED_IN_LAST_X_DAYS'];
export const OPERATORS_WITH_TIME_POINT = ['IS_AFTER_DATE', 'IS_BEFORE_DATE', 'IS_MORE_THAN_X_DAYS_AGO', 'IS_MORE_THAN_X_DAYS_FROM_NOW', 'IS_AFTER_PROPERTY', 'IS_BEFORE_PROPERTY', 'IS_UPDATED_AFTER_PROPERY', 'IS_UPDATED_BEFORE_PROPERTY'];
export const OPERATORS_WITH_UPPER_AND_LOWER_BOUND = ['IS_EQUAL', 'IS_BETWEEN', 'IS_NOT_BETWEEN', 'IS_LESS_THAN_X_DAYS_AGO', 'IS_LESS_THAN_X_DAYS_FROM_NOW', 'IS_UPDATED_IN_LAST_X_DAYS', 'IS_NOT_UPDATED_IN_LAST_X_DAYS'];

/* There aren't unique ILS operators for the unique UI operators,
so this is the only way to be sure we're getting the right filter for the UI
EX: "is between", "is equal to", "is less than X days ago",
"is less than X days from now", and "is updated in the last X days"
all use the IS_BETWEEN operator under the hood */
export const isInTimePointOperatorList = (filter, timePointOperatorOverrideAllowList) => {
  if (!timePointOperatorOverrideAllowList || !('operation' in filter) || !filter.operation) {
    return false;
  }
  const operation = 'toJS' in filter.operation ? filter.operation.toJS() : filter.operation;
  return timePointOperatorOverrideAllowList.some(timePointOperator => {
    switch (timePointOperator) {
      case 'IS_EQUAL':
        {
          return isEqualToDateOperation(operation);
        }
      case 'IS_BETWEEN':
        {
          return isBetweenDatesOperation(operation);
        }
      case 'IS_NOT_BETWEEN':
        {
          return isNotBetweenDatesOperation(operation);
        }
      case 'IS_AFTER_DATE':
        {
          return isAfterDateOperation(operation);
        }
      case 'IS_BEFORE_DATE':
        {
          return isBeforeDateOperation(operation);
        }
      case 'IS_MORE_THAN_X_DAYS_AGO':
        {
          return isMoreThanXDaysAgoOperation(operation);
        }
      case 'IS_MORE_THAN_X_DAYS_FROM_NOW':
        {
          return isMoreThanXDaysFromNowOperation(operation);
        }
      case 'IS_LESS_THAN_X_DAYS_AGO':
        {
          return isLessThanXDaysAgoOperation(operation);
        }
      case 'IS_LESS_THAN_X_DAYS_FROM_NOW':
        {
          return isLessThanXDaysFromNowOperation(operation);
        }
      case 'IS_AFTER_PROPERTY':
        {
          return isAfterPropertyOperation(operation);
        }
      case 'IS_BEFORE_PROPERTY':
        {
          return isBeforePropertyOperation(operation);
        }
      case 'IS_UPDATED_IN_LAST_X_DAYS':
        {
          return isUpdatedInLastXDaysOperation(operation);
        }
      case 'IS_NOT_UPDATED_IN_LAST_X_DAYS':
        {
          return isNotUpdatedInLastXDaysOperation(operation);
        }
      case 'IS_UPDATED_AFTER_PROPERY':
        {
          return isUpdatedAfterPropertyOperation(operation);
        }
      case 'IS_UPDATED_BEFORE_PROPERTY':
        {
          return isUpdatedBeforePropertyOperation(operation);
        }
      default:
        {
          return false;
        }
    }
  });
};
export const getTimePointOperator = filter => {
  if (!('operation' in filter) || !filter.operation) {
    return undefined;
  }
  const operation = 'toJS' in filter.operation ? filter.operation.toJS() : filter.operation;
  if (isEqualToDateOperation(operation)) {
    return 'IS_EQUAL';
  } else if (isBetweenDatesOperation(operation)) {
    return 'IS_BETWEEN';
  } else if (isNotBetweenDatesOperation(operation)) {
    return 'IS_NOT_BETWEEN';
  } else if (isAfterDateOperation(operation)) {
    return 'IS_AFTER_DATE';
  } else if (isBeforeDateOperation(operation)) {
    return 'IS_BEFORE_DATE';
  } else if (isMoreThanXDaysAgoOperation(operation)) {
    return 'IS_MORE_THAN_X_DAYS_AGO';
  } else if (isMoreThanXDaysFromNowOperation(operation)) {
    return 'IS_MORE_THAN_X_DAYS_FROM_NOW';
  } else if (isLessThanXDaysAgoOperation(operation)) {
    return 'IS_LESS_THAN_X_DAYS_AGO';
  } else if (isLessThanXDaysFromNowOperation(operation)) {
    return 'IS_LESS_THAN_X_DAYS_FROM_NOW';
  } else if (isAfterPropertyOperation(operation)) {
    return 'IS_AFTER_PROPERTY';
  } else if (isBeforePropertyOperation(operation)) {
    return 'IS_BEFORE_PROPERTY';
  } else if (isUpdatedInLastXDaysOperation(operation)) {
    return 'IS_UPDATED_IN_LAST_X_DAYS';
  } else if (isNotUpdatedInLastXDaysOperation(operation)) {
    return 'IS_NOT_UPDATED_IN_LAST_X_DAYS';
  } else if (isUpdatedAfterPropertyOperation(operation)) {
    return 'IS_UPDATED_AFTER_PROPERY';
  } else if (isUpdatedBeforePropertyOperation(operation)) {
    return 'IS_UPDATED_BEFORE_PROPERTY';
  } else {
    return undefined;
  }
};
export const areTimePointFiltersEqual = (value1, value2) => {
  const value1TimePointOperator = getTimePointOperator(value1);
  const value2TimePointOperator = getTimePointOperator(value2);
  if (!value1TimePointOperator || !value2TimePointOperator || value1TimePointOperator !== value2TimePointOperator || value1.property !== value2.property) {
    return false;
  }
  if (isInTimePointOperatorList(value1, OPERATORS_WITH_TIME_POINT)) {
    const value1TimePoint = value1.get('operation').get('timePoint').toJS();
    const value2TimePoint = value2.get('operation').get('timePoint').toJS();

    // differences in offset are important and shouldn't just be checked for subset
    // https://issues.hubspotcentral.com/browse/WORKFLOWS-16776
    const areOffsetsEqual = isEqual(value1TimePoint.offset, value2TimePoint.offset);
    return areOffsetsEqual && (isSubset(value1TimePoint, value2TimePoint) || isSubset(value2TimePoint, value1TimePoint));
  } else if (isInTimePointOperatorList(value1, OPERATORS_WITH_UPPER_AND_LOWER_BOUND)) {
    const value1UpperBoundTimePoint = value1.get('operation').get('upperBoundTimePoint').toJS();
    const value1LowerBoundTimePoint = value1.get('operation').get('lowerBoundTimePoint').toJS();
    const value2UpperBoundTimePoint = value2.get('operation').get('upperBoundTimePoint').toJS();
    const value2LowerBoundTimePoint = value2.get('operation').get('lowerBoundTimePoint').toJS();

    // differences in offset are important and shouldn't just be checked for subset
    // https://issues.hubspotcentral.com/browse/WORKFLOWS-16776
    const areOffsetsEqual = isEqual(value1UpperBoundTimePoint.offset, value2UpperBoundTimePoint.offset) && isEqual(value1LowerBoundTimePoint.offset, value2LowerBoundTimePoint.offset);

    // use isSubset because the BE returns more data than we send, like adding timezoneSource
    return areOffsetsEqual && (isSubset(value1UpperBoundTimePoint, value2UpperBoundTimePoint) || isSubset(value2UpperBoundTimePoint, value1UpperBoundTimePoint)) && (isSubset(value1LowerBoundTimePoint, value2LowerBoundTimePoint) || isSubset(value2LowerBoundTimePoint, value1LowerBoundTimePoint));
  }
  return false;
};
function isSubset(superset, subset) {
  return isEqualWith(superset, subset, (_superset, _subset, key) => {
    return !_subset[key] || undefined;
  });
}